export default {
  getApiError (response) {
    let error = response.body['msg']
    if (error) {
      return error
    } else {
      return response.statusText
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/errors.js